// src/locales/en/categories.js
export const categories = {
  // Page titles and descriptions
  title: "Product Categories",
  description: "Organize your products with hierarchical categories for better management",
  
  // Navigation
  addCategory: "Add Category",
  createNewCategory: "Create New Category",
  editCategory: "Edit Category",
  createFirstCategory: "Create First Category",
  allCategories: "All Categories",
  
  // Form Fields
  categoryName: "Category Name",
  categoryNamePlaceholder: "Enter category name (e.g., Electronics, Clothing)",
  parentCategory: "Parent Category",
  selectParentCategory: "Select parent category (optional)",
  
  // Search and Navigation
  searchCategories: "Search categories...",
  createUnder: "Create under",
  
  // Table Headers and Info
  totalCategories: "{{count}} categories",
  
  // Validation Messages
  nameRequired: "Category name is required",
  nameMinLength: "Category name must be at least 2 characters",
  
  // Actions
  createCategory: "Create Category",
  updateCategory: "Update Category",
  
  // Success/Error Messages
  categoryCreatedSuccess: "Category '{{categoryName}}' created successfully!",
  categoryUpdatedSuccess: "Category '{{categoryName}}' updated successfully!",
  categoryDeletedSuccess: "Category '{{categoryName}}' has been deleted successfully.",
  failedToCreate: "Failed to create category. Please try again.",
  failedToUpdate: "Failed to update category. Please try again.",
  failedToDelete: "Failed to delete category. Please try again.",
  failedToLoadCategory: "Failed to load category details. Please try again.",
  
  // Loading states
  loadingCategories: "Loading Categories...",
  loadingCategoriesDesc: "Please wait while we fetch your product categories.",
  
  // Empty states
  noCategories: "No categories yet",
  noCategoriesDesc: "Create your first product category to start organizing your products.",
  noSearchResults: "No categories found",
  noSearchResultsDesc: "Try adjusting your search terms or clear filters to see all categories.",
  
  // Confirmation dialogs
  confirmDelete: "Are you sure you want to delete the category '{{categoryName}}'? This action cannot be undone and may affect products using this category."
};